import React, { useState } from 'react';
import html2pdf from 'html2pdf.js';

export const HtmlToPdfView: React.FC = () => {
  const [htmlContent, setHtmlContent] = useState<string>('');
  const [isProcessing, setIsProcessing] = useState(false);

  const handleConvert = () => {
    if (!htmlContent.trim()) return;
    setIsProcessing(true);
    
    // Create a temporary div to hold the HTML
    const container = document.createElement('div');
    container.innerHTML = htmlContent;
    container.style.width = '800px'; // Set a fixed width for desktop-like rendering
    container.style.padding = '20px';
    container.style.background = 'white';
    container.style.color = 'black';
    
    // Must append to DOM for html2canvas to render computed styles correctly, but hide it off-screen
    container.style.position = 'absolute';
    container.style.left = '-9999px';
    document.body.appendChild(container); 

    const opt = {
      margin:       10,
      filename:     'converted_webpage.pdf',
      image: { type: 'jpeg' as const, quality: 0.98 },
      html2canvas:  { scale: 2, useCORS: true },
      jsPDF:        { unit: 'mm', format: 'a4', orientation: 'portrait' as const }
    };

    html2pdf().set(opt).from(container).save().then(() => {
      document.body.removeChild(container);
      setIsProcessing(false);
    }).catch((err: unknown) => {
      console.error(err);
      document.body.removeChild(container);
      setIsProcessing(false);
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, padding: '1rem' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        <div>
          <h2 style={{ margin: 0 }}>HTML to PDF</h2>
          <p style={{ margin: '0.25rem 0 0', color: 'var(--color-text-secondary)' }}>Paste your raw HTML code to convert it into a fully formatted PDF document.</p>
        </div>
        <button onClick={() => { handleConvert(); }} disabled={isProcessing || !htmlContent.trim()} style={{ padding: '0.5rem 1rem', background: 'var(--color-accent)', color: 'var(--color-on-accent)', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: 600 }}>
          {isProcessing ? 'Converting...' : 'Convert to PDF'}
        </button>
      </div>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <textarea
          value={htmlContent}
          onChange={(e) => { setHtmlContent(e.target.value); }}
          placeholder="Paste your HTML code here (e.g. <h1>Hello World</h1>)..."
          style={{ flex: 1, padding: '1rem', borderRadius: '8px', border: '1px solid var(--color-border)', resize: 'none', fontFamily: 'monospace' }}
        />
      </div>
    </div>
  );
};
